import { EMOJI_SHORTCODE } from './constants';

const shortcodes = Object.keys(EMOJI_SHORTCODE).sort();

export default (search, { startsWith = true, includes = true, max = 5 } = {}) => {
  if (!search) return undefined;

  const set = new Set();

  let i = 0;
  while (startsWith && set.size < max && i < shortcodes.length) {
    if (shortcodes[i].startsWith(search)) {
      set.add(shortcodes[i]);
    }
    i += 1;
  }

  i = 0;
  while (includes && set.size < max && i < shortcodes.length) {
    if (shortcodes[i].includes(search)) {
      set.add(shortcodes[i]);
    }
    i += 1;
  }

  return [...set];
};
